import { jsx } from '@emotion/react/jsx-runtime';
import { Children, cloneElement } from 'react';
import { mergeThemes } from '../utils/themes.js';
import { accordion } from './styles.js';
import { transformProviderTheme, themeAccordion } from './theme.js';
const Accordion = ({ hideToggleLabel = false, children, cssOverrides, theme, ...props }) => {
    const mergedTheme = (providerTheme) => mergeThemes(themeAccordion, theme, providerTheme, transformProviderTheme);
    return /* @__PURE__ */ jsx("div", {
        css: (providerTheme) => [
            accordion(mergedTheme(providerTheme.accordion)),
            cssOverrides
        ],
        ...props,
        children: Children.map(children, (child) => {
            return cloneElement(child, { hideToggleLabel });
        })
    });
};
export { Accordion };
